'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rxFetch = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _ajax = require('rxjs/observable/dom/ajax');

var rxFetch = exports.rxFetch = function rxFetch(url, settings) {
  return (0, _ajax.ajax)(_extends({
    url: url,
    headers: settings.headers,
    crossDomain: true,
    async: true,
    responseType: settings.responseType || 'json'
  }, settings));
};